import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import ProfileInfo from '@/components/profile/ProfileInfo.tsx';
import ChangePassword from '@/components/profile/ChangePassword.tsx';
import AccountInfo from '@/components/profile/AccountInfo.tsx';
import DataExportSection from '@/components/profile/DataExportSection.tsx';

export default function ProfilePage() {
  const { t } = useTranslation();

  return (
    <>
      <h1 className="mb-8 text-3xl font-heading text-foreground">
        {t('profile.pageTitle')}
      </h1>
      <div className="grid gap-8 lg:grid-cols-2">
        <ProfileInfo />
        <ChangePassword />
      </div>
      <div className="mt-8">
        <AccountInfo />
      </div>
      <div className="mt-8">
        <Link
          to="/data-privacy"
          className="flex items-center gap-2.5 rounded-xl border border-border bg-card px-5 py-4 text-sm text-muted-foreground hover:text-foreground hover:border-primary/30 transition-colors"
        >
          <Shield className="h-5 w-5 text-primary" />
          <span>{t('dataPrivacy.profileLink')}</span>
        </Link>
      </div>
      <div className="mt-8">
        <DataExportSection />
      </div>
    </>
  );
}
